import gateway from "./gateway";
import session from "./session";

export default {
  fetchAddressSearch(code){
    return gateway.get(`/telco-provisioning/v1/address/search/?postcode=${code}`);
  },
  fetchTelcoProvisioning(pid) {
    return session.get(`/telco/lines/${pid}/`);
  },
  updateTelcoProvisioning(pid,data){
    return session.patch(`/telco/lines/${pid}/`,JSON.stringify(data));
  },
  getTelcoTariffs(version,kind) {
    let kindStr = (kind!==undefined)?`&product_kind=${kind}`:``;
    return session.get(`/pricing/tariffs/?tariff_version=${version}${kindStr}`);
  },
  sendApptReminder(p_id) {
    return session.post(`/telco/lines/${p_id}/actions/send-appt-reminder/`,JSON.stringify({}));
  },
  fetchTelcoOrderTypes() {
    return session.get('/static-data/options/?object_kind=TelcoProduct&field=order_type');
  }
}
